import { mapState } from 'vuex'

const getTitle = vm => {
    const { title } = vm.$options
    if (title) {
        return typeof title === 'function' ?
            title.call(vm) :
            title
    }
}

const clientTitleMixin = {
    computed: {
        ...mapState([
            'aboutActive',
        ]),
    },
    methods: {
        setDocumentTitle() {
            const title = this.aboutActive ? 'About' : getTitle(this)
            const baseTitle = 'Genomic Cytometry'
            if (title) {
                document.title = `${title} | ${baseTitle}`
            } else {
                document.title = baseTitle
            }
        },
    },
    mounted() {
        this.setDocumentTitle()
    },
    updated() {
        this.setDocumentTitle()
    },
    beforeRouteUpdate(to, from, next) {
        this.setDocumentTitle()
        next()
    },
}

export default clientTitleMixin
